import { OverallValidationResult, validator } from '../../../../util'
import { PortfolioStepState } from '../portfolio-slice'
import { selfSelectRules } from './self-select'

const selfSelectValidator = validator(selfSelectRules)

export function validate(portfolio: PortfolioStepState): OverallValidationResult {
  switch (portfolio.portfolioType) {
    case 'SelfSelect':
      return selfSelectValidator(portfolio)
  }
}
